import styled from 'styled-components';
import { Indicator, ToggleBackground } from '../ModeToggle/FormModeToggleStyles';

export const ToggleContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 24px;
  z-index: 99999999;

  &.has-version-toggle {
    @media (max-width: 850px) {
      top: 50px;
    }
  }
`;

export const ToggleDeviceBackground = styled(ToggleBackground)`
  button {
    width: 33.33%;
  }
`;

const indicatorPositionMap = {
  desktop: {
    left: '2px',
  },
  tablet: {
    left: 'calc(33.33% + 2px)',
  },
  mobile: {
    left: 'calc(66.66% - 2px)',
  },
};

export const DeviceIndicator = styled(Indicator)`
  left: ${props => indicatorPositionMap[props.activeItem]?.left || '4px'};
  width: 33.33%;
  top: 2px;
  height: calc(100% - 4px);
`;